import homeTopSlides from "~/js/sections/root/includes/home-top-slides";
import "~/js/sections/root/includes/slider-countdown";

const topSlides = [];
const topSliderWrap = document.querySelector("#hero-slider .slide-wrap");
let counter = 0;
const caption = document.getElementById("caption");
const playPause = document.getElementById("playPause");
const $sliderTop = $("#hero-slider .slide-wrap");
const instagramDots = require("~/js/components/global/NavDots");

const slickSlider = () => {
  const $statusSliderTop = $("#hero-slider .js-slick-slider-top-counter");

  $sliderTop.on("init", (event, slick, currentSlide) => {
    caption.innerHTML = homeTopSlides.slides[0].caption;

    const i = (currentSlide ? currentSlide : 0) + 1;
    const dotsWrap = document.querySelector("#hero-slider .slick-dots");
    const dots = Array.from(dotsWrap.querySelectorAll("li"));

    $statusSliderTop.text(`${i}/${slick.slideCount}`);

    const srcs = $sliderTop
      .find(`div[data-slick-index='0']`)
      .find(".slider-item-inner picture source");
    const img = $sliderTop
      .find(`div[data-slick-index='0']`)
      .find(".slider-item-inner picture img");
    srcs.each(function () {
      const imgSrc = $(this).attr("data-srcset");
      $(this).attr("srcset", imgSrc);
    });
    img.attr("src", img.attr("data-src"));

    if (dots.length > 5) {
      dots.forEach((dot, index) => {
        if (index <= 2) {
          dot.classList.add("large");
        } else if (index === 3) {
          dot.classList.add("semi");
        } else if (index === 4) {
          dot.classList.add("small");
        } else {
          dot.classList.add("none");
        }
      });
      instagramDots(dotsWrap, $sliderTop);
    }
  });

  $sliderTop.on("reInit afterChange", (event, slick, currentSlide) => {
    const i = (currentSlide ? currentSlide : 0) + 1;

    $statusSliderTop.text(`${i}/${slick.slideCount}`);
  });

  $sliderTop.slick({
    centerMode: true,
    centerPadding: "0",
    cssEase: "ease-out",
    dots: true,
    fade: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 8000,
    prevArrow: $("#hero-slider .js-prev-slide-in-slider-top"),
    nextArrow: $("#hero-slider .js-next-slide-in-slider-top"),
  });

  $sliderTop.on("beforeChange", (event, slick, currentSlide, nextSlide) => {
    caption.innerHTML = homeTopSlides.slides[nextSlide].caption;

    if (nextSlide === -1) {
      return false;
    }
    if (nextSlide <= slick.slideCount - 1) {
      const srcs = $sliderTop
        .find(`div[data-slick-index='${nextSlide}']`)
        .find(".slider-item-inner picture source");
      const img = $sliderTop
        .find(`div[data-slick-index='${nextSlide}']`)
        .find(".slider-item-inner picture img");
      srcs.each(function () {
        const imgSrc = $(this).attr("data-srcset");
        $(this).attr("srcset", imgSrc);
      });
      img.attr("src", img.attr("data-src"));
    }
    if (nextSlide <= slick.slideCount - 2) {
      const srcs = $sliderTop
        .find(`div[data-slick-index='${nextSlide + 1}']`)
        .find(".slider-item-inner picture source");
      const img = $sliderTop
        .find(`div[data-slick-index='${nextSlide + 1}']`)
        .find(".slider-item-inner picture img");
      srcs.each(function () {
        const imgSrc = $(this).attr("data-srcset");
        $(this).attr("srcset", imgSrc);
      });
      img.attr("src", img.attr("data-src"));
    }
    if (nextSlide <= slick.slideCount - 3) {
      const srcs = $sliderTop
        .find(`div[data-slick-index='${nextSlide + 2}']`)
        .find(".slider-item-inner picture source");
      const img = $sliderTop
        .find(`div[data-slick-index='${nextSlide + 2}']`)
        .find(".slider-item-inner picture img");
      srcs.each(function () {
        const imgSrc = $(this).attr("data-srcset");
        $(this).attr("srcset", imgSrc);
      });
      img.attr("src", img.attr("data-src"));
    }
  });
};


$(playPause).click((event) => {
  if (event.target.classList.contains("pause")) {
    $sliderTop.slick("slickPause");
    $(playPause).removeClass("play").addClass("pause");
   
  } else {
    $sliderTop.slick("slickPlay");
    $(playPause).removeClass("pause").addClass("play");
   
  }
});

homeTopSlides.slides.forEach((slide, index, array) => {
  const linkText = slide.anchorText !== "" ? slide.anchorText : "Learn More";
  if (slide.theme) {
    topSlides.push(`
            <div class="slider-item specials-slide">	
                <div class="slider-item awards-slide">
                    <div class="slider-item-inner">
                        <a href=${slide.link} class="whole-slide" data-ibm="HP Top Carousel-_-BTC reopening-_-N/A">
                            <picture>
                                <source media='(max-width: 767px)' data-srcset=${slide.imgMobile}>
                                <source media='(max-width: 1023px)' data-srcset=${slide.imgTablet}>
                                <source media='(min-width: 1024px)' data-srcset=${slide.imgDesktop}>
                                <img class="img-pcnt" src=${slide.imgDesktop} altText="">
                            </picture>
                        </a>
                    </div>
                </div>
            </div>
        `);
  } else if (!slide.customizeLayout) {
        topSlides.push(`
            <div class='slider-item ${slide.idName}'>
                    <div class='slider-item-inner'>
                        <div class='container'>
                            <div class='row'>
                                <div class='xs-12 blue-bar ${!slide.leftAligned && 'right'}'>
                                    ${slide.topText}
                                    ${slide.bottomText}
                                    ${slide.link !== '' ? `<a class="learn-more" href=${slide.link} data-ibm=${slide.ibmClickTag}> ${linkText}</a>` : ''}
                                    ${slide.additionalElements}
                                </div>
                            </div>
                        </div>
                        ${!slide.video ? 
                          `<picture> 
                            <source media='(max-width: 767px)' data-srcset=${slide.imgMobile}>
                            <source media='(max-width: 1023px)' data-srcset=${slide.imgTablet}>
                            <source media='(min-width: 1024px)' data-srcset=${slide.imgDesktop}>
                            <img src='data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7' data-src=${slide.imgDesktop}>
                          </picture>` : ''
                        }
                        ${slide.video ? `<video autoplay loop muted playsinline> <source type='video/mp4' src=${slide.videoLinkMP4}> <source type='video/webm' src=${slide.videoLinkWebM}> <img src=${slide.imgMobile} /></video>` : ''}
                    </div>
            </div>
        `);
    } else {
        topSlides.push(`
            <div class='slider-item ${slide.idName}'>
                <div class='slider-item-inner'>
                ${slide.additionalElements}
                ${slide.link != '' ?
                  `<a href=${slide.link} class="whole-slide" data-ibm="HP Top Carousel-_-BTC reopening-_-N/A">
                    <picture>
                      <source media='(max-width: 767px)' data-srcset=${slide.imgMobile}>
                      <source media='(max-width: 1023px)' data-srcset=${slide.imgTablet}>
                      <source media='(min-width: 1024px)' data-srcset=${slide.imgDesktop}>
                      <img src='data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7' data-src=${window.innerWidth > 768 ? slide.imgDesktop : slide.imgMobile}>
                    </picture>
                  </a>
                  `
                  : `<picture>
                      <source media='(max-width: 767px)' data-srcset=${slide.imgMobile}>
                      <source media='(max-width: 1023px)' data-srcset=${slide.imgTablet}>
                      <source media='(min-width: 1024px)' data-srcset=${slide.imgDesktop}>
                      <img src='data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7' data-src=${window.innerWidth > 768 ? slide.imgDesktop : slide.imgMobile}>
                    </picture>`
                }
                </div>
            </div>
        `);
    }

  counter++;
  if (counter === array.length) {
    $(topSliderWrap).append(topSlides.join(""));
    slickSlider();

    if (window.innerWidth > 767) {
      $sliderTop.slick("slickPlay");
    }
  }
});
